import staging from './staging';

export default Object.assign({}, staging, {
  ENV: 'testing',
  STRIPE_DEVELOPMENT_MODE: true,
  BASE_URL: 'https://api-testing.mozio.com',
  BASE_URL_V2: 'https://api-testing.mozio.com/v2',
  GOOGLE_ANALYTICS_KEY_PARTNER: '',
  SHOW_TICKET_PASSES_SELECTION: true,
  EXPERIMENTS_ENABLED: false,
});
